import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/GridDocumentedProps";

export default class Grid extends React.Component {
    render() {
        let dataTqId = {};
        if (this.props.dataTqId) {
            dataTqId = { "data-tq-id": this.props.dataTqId };
        }

        return (
            <div className={this.buildClass()} {...dataTqId}>
                {this.props.children}
            </div>
        );
    }

    buildClass() {
        let gridClassName = "tq-grid-a";
        if (this.props.extraClasses) {
            gridClassName += ` ${this.props.extraClasses}`;
        }
        return gridClassName;
    }
}

Grid.displayName = "Grid";

Grid.propTypes = {
    extraClasses: PropTypes.string,
    dataTqId: PropTypes.string
};

Grid.documentedProps = documentedProps;
